
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xmlns:a": "http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/",
    "x": "0px",
    "y": "0px",
    "width": "40px",
    "height": "40px",
    "viewBox": "0 0 40 40",
    "enable-background": "new 0 0 40 40",
    "xml:space": "preserve"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "g",
      "children": [
        {
          "tag": "path",
          "attrsMap": {
            "fill": "#51565D",
            "d": "M40,31.488C40,36.17,36.17,40,31.489,40H8.511C3.83,40,0,36.17,0,31.488V8.512C0,3.83,3.83,0,8.511,0\r\n\t\th22.978C36.17,0,40,3.83,40,8.512V31.488z"
          }
        }
      ]
    },
    {
      "tag": "g",
      "children": [
        {
          "tag": "g",
          "children": [
            {
              "tag": "path",
              "attrsMap": {
                "fill": "#BBBBBB",
                "d": "M30.615,18.864c0.318-0.728,0.496-1.529,0.496-2.373c0-3.291-2.666-5.959-5.959-5.959\r\n\t\t\tc-1.114,0-2.152,0.311-3.043,0.842c-1.346-1.635-3.383-2.676-5.666-2.676c-4.051,0-7.334,3.281-7.334,7.334\r\n\t\t\tc0,0.455,0.049,0.896,0.127,1.328c-2.219,0.867-3.793,3.021-3.793,5.547c0,3.291,2.668,5.958,5.961,5.958h18.33\r\n\t\t\tc2.787,0,5.043-2.257,5.043-5.041C34.777,21.341,32.982,19.282,30.615,18.864z M22.609,24.806l-2.674,2.127\r\n\t\t\tc-0.301,0.239-0.74,0.023-0.74-0.364v-1.395c-2.573-0.23-4.584-2.388-4.584-5.017c0-0.708,0.146-1.379,0.412-1.988\r\n\t\t\tc0.072-0.166,0.217-0.289,0.39-0.337c0.175-0.047,0.362-0.009,0.507,0.099l0.545,0.408c0.213,0.16,0.293,0.441,0.195,0.688\r\n\t\t\tc-0.139,0.351-0.217,0.732-0.217,1.131c0,1.614,1.199,2.938,2.752,3.162v-1.323c0-0.387,0.439-0.605,0.74-0.364l2.674,2.126\r\n\t\t\tC22.943,24.023,22.941,24.541,22.609,24.806z M24.281,22.146c-0.07,0.167-0.217,0.289-0.391,0.337\r\n\t\t\tc-0.176,0.044-0.363,0.01-0.506-0.1l-0.545-0.409c-0.213-0.159-0.293-0.44-0.195-0.688c0.137-0.351,0.215-0.728,0.215-1.128\r\n\t\t\tc0-1.615-1.197-2.938-2.75-3.162v1.322c0,0.387-0.439,0.604-0.74,0.367l-2.674-2.128c-0.334-0.267-0.334-0.786,0-1.049\r\n\t\t\tl2.674-2.127c0.301-0.239,0.74-0.021,0.74,0.366v1.392c2.57,0.232,4.586,2.389,4.586,5.019\r\n\t\t\tC24.695,20.864,24.547,21.536,24.281,22.146z"
              }
            }
          ]
        }
      ]
    }
  ]
})
    }
  